import "./style.scss";

import React, { useState } from "react";

import { Input } from "../input/input";
import { formatNumber } from "../../field/renderer";
import { t } from "i18next";
import { Tooltip } from "@mui/material";

interface IScanFieldProps {
    scanFieldType: "text" | "number";
    label: string;
    tooltipTitle: string;
    onScan: (value: any) => void;
    autofocus?: boolean;
    forceFocus?: boolean;
    disabled?: boolean;
}

export const ScanField = (props: IScanFieldProps) => {
    const [scanValue, setScanValue] = useState("");

    const onChange = (value: string) => {
        if (props.scanFieldType === "number") {
            setScanValue(formatNumber(value));
        } else {
            setScanValue(value);
        }
    };

    const onKeyDown = (keyDown: string) => {
        if (keyDown === "Enter") {
            props.onScan(scanValue);
            setScanValue("");
        }
    };

    const renderScanField = () => {
        return <div className={"scanField"}>
            <Input propertyKey="scanField" errors={[]}
                   value={scanValue}
                   onKeyDown={keyDown => onKeyDown(keyDown)}
                   onChange={value => onChange(value ?? "")}
                   label={t(props.label)}
                   htmlType="string"
                   autoFocus={props.autofocus}
                   disabled={props.disabled}
                   isLabelShrunk={true}
            />
        </div>;
    };

    return <>
        {props.tooltipTitle
            ? <Tooltip title={t(props.tooltipTitle)} placement="right-start">
                {renderScanField()}
              </Tooltip>
            : renderScanField()}
    </>;
};
